import {makeAutoObservable} from "mobx";



const languageCodes = ["EN", "KO", "ZH", "JA", "TH", "VN", "MN", "ID", "RU", "TW"];

const languageLocaleMap = {
    "US": "EN",
    "KR": "KO",
    "CN": "ZH",
    "JP": "JA",
    "TH": "TH",
    "VN": "VN",
    "MN": "MN",
    "ID": "ID",
    "RU": "RU",
    "TW": "TW",
    "ETC": "ETC",
};

const defaultBanner = {
    createdDatetime: "",
    isEnable: true,
    id: 0,
    notificationId: 0,
    subTitle: "",
    title: "",
    updatedDatetime: ""
};

const noticeContents = {
    content: "",
    createdDatetime: "",
    id: 0,
    notificationId: 0,
    updatedDatetime: "",
};

export const NotificationType = {
    All: 'All',
    Locale: 'Locale',
    Group: 'Group',
    Select: 'select'
}

export const TabType = {
    title: 'title',
    subTitle: 'subTitle',
}

const logPrefix = "[NoticeStore]"

export default class NoticeStore {

    constructor(props) {
        this.notificationRepository = props.notificationRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;
        this.localeStore = props.localeStore;

        this.rowsPerPage = 10;
        this.page = 0;
        this.sortColumn = '';
        this.isAscending = true;
        this.enableCheck = true;

        this.previewIndex = 0;

        this.noticeList = [];
        this.totalCount = 0;

        this.initNoticeDetailInfo();

        makeAutoObservable(this);

    }

    initNoticeDetailInfo = () => {

        this.background = "#F7F7F7";
        this.noticeBanners = languageCodes.map(code => ({...defaultBanner, languageCode: code}));
        this.detailImages = [];
        this.noticeContents = languageCodes.map(code => ({...noticeContents, languageCode: code}));
        this.notificationImage = [
            {
                createdDatetime: "",
                id: 0,
                image: "",
                notificationId: 0,
                updatedDatetime: "",
            }
        ];
        this.isImageChange = false;
        this.id = 0;
        this.localeCode = "";
        this.localeGroupId = 0;
        this.type = "";

        this.title = "";
        this.subtitle = "";
        this.content = "";

        this.currentPage = true;
        this.currentTab = "title";

        this.selectOption = "All";
        this.selectLocale = "select";
        this.selectGroupId = "";
    }

    initNoticeList = () => {
        this.noticeList = [];
        this.totalCount = 0;
        console.log(logPrefix, 'Initialize Notice');
    }

    initNotificationImage = () => {
        this.notificationImage = {
            createdDatetime: "",
            id: 0,
            image: "",
            notificationId: 0,
            updatedDatetime: "",
        };
    }

    initDetailImage = (index) => {
        this.detailImages.splice(index, 1);
    }

    setRowsPerPage = (rowsPerPage, id, locale) => {
        this.page = 0;
        this.rowsPerPage = rowsPerPage;
        this.getNotifications(id, locale);

    }

    setPage = (page, id, locale) => {
        this.page = page;
        this.getNotifications(id, locale);
    }

    setPreviewIndex = (num) => {
        if (num >= 0 && num <= this.detailImages.length) {
            this.previewIndex = num;
        }
    }

    setSortColumn = (column) => {
        this.sortColumn = column;
    }

    setCurrentPage = (boolean) => {
        this.currentPage = !boolean;
    }

    setCurrentTab = (text) => {
        this.currentTab = text;
    }

    setIsAscending = (isAscending) => {
        this.isAscending = isAscending;
    }

    setEnableCheck = (boolean) => {
        this.enableCheck = boolean;
    }

    setEnable = (enable, index) => {
        this.noticeBanners[index].isEnable = !enable;
    }

    setNoticeList = (list) => {
        this.noticeList = list;
    }

    setDetailImages = (array) => {
        if (array !== null) {
            this.detailImages = array;
        }
    }

    pushDetailImages = (array) => {
        this.detailImages.push(array)
    }

    setNotificationImage = (array) => {
        if (array !== null) {
            this.notificationImage = array;
        }
    }

    setLocaleGroupId = (id) => {
        this.localeGroupId = id;
    }

    setType = (type) => {
        this.type = type;
    }

    setTotalCount = (count) => {
        this.totalCount = count;
    }

    setNoticeBanners = (array, locale) => {
        this.noticeBanners = array;

        array.forEach(item => {
            if (item.languageCode === locale) {
                this.setTitle(item.title);
                this.setSubtitle(item.subTitle);
            }
        });
    }

    setNoticeContents = (array, locale) => {
        this.noticeContents = array;

        array.forEach(item => {
            if (item.languageCode === locale) {
                this.setContent(item.content);
            }
        });
    }

    setTitle = (title) => {
        this.title = title;
    };

    setSubtitle = (subtitle) => {
        this.subtitle = subtitle;
    };

    setContent = (content) => {
        this.content = content;
    }

    setBackground = (color) => {
        this.background = color;
    }

    setId = (id) => {
        this.id = id;
    }

    setLocaleCode = (code) => {
        this.localeCode = code;
    }

    setSelectOption = (option, callback) => {
        if (option === "All") {
            this.setSelectLocale("select");
            this.setSelectGroupId("");
            this.noticeBanners = languageCodes.map(code => ({...defaultBanner, languageCode: code}));
            this.noticeContents = languageCodes.map(code => ({...noticeContents, languageCode: code}));
        }
        this.selectOption = option;
        callback && callback();
    }

    setSelectLocale = (locale) => {
        this.selectLocale = locale;
    }

    setSelectGroupId = (groupId) => {
        this.selectGroupId = groupId;
        if (groupId === "All" && this.selectOption === "Group") {
            this.setSelectOption("Locale");
        }
    }

    getCurrentIndexWithLangCode = (languageCode) => {
        return this.noticeContents.findIndex(notice => notice.languageCode === languageCode);
    }

    setNoticeTranslations = async (lang, type, data, callback) => {
        const targetArray = type === "content" ? this.noticeContents : this.noticeBanners;

        for (const content of targetArray) {
            if (data.length && data.length > 0) {
                for (const datum of data) {
                    if (lang !== content.languageCode && content.languageCode === datum.lang) {
                        content[type] = datum.translation;
                    }
                }
            }
        }
        await callback && callback();
    }

    setNoticeElement = (index, type, value) => {
        if (type === "content") {
            this.noticeContents[index][type] = value;
        } else {
            this.noticeBanners[index][type] = value;
        }
    }
    setImageChange = () => {
        this.isImageChange = true;
    }

    * translateNotice(index, targetLang, currentLang, text, type, callback) {
        this.commonStore.setLoadingState('Translating...');
        try {
            console.log(logPrefix, 'Start translate Notice.');
            const url = `translate?target-lang=${targetLang}&current-lang=${currentLang}&text=${text}`
            const response = yield this.notificationRepository.getNotificationInfo(url);
            callback && callback(index, type, response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed translate Notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * translateAllNotice(lang, text, type, callback) {
        this.commonStore.setLoadingState('Translating...');
        try {
            console.log(logPrefix, 'Start translate All Notice.');
            const url = `translate/all?lang=${lang}&text=${text}`;
            const response = yield this.notificationRepository.getNotificationInfo(url);
            callback && callback(lang, type, response.data, this.commonStore.initLoadingState);
        } catch (e) {
            console.log(logPrefix, 'Failed translate All Notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getNotifications(id, locale, callback) {
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start Get Notification');
            const url = `?userId=${id}&isAscending=${this.isAscending}&lang=${locale.toUpperCase()}&limit=${this.rowsPerPage}&offset=${this.page * this.rowsPerPage}`;
            const response = yield this.notificationRepository.getNotifications(url);
            this.setNoticeList(response.data.notificationRes);
            this.setTotalCount(response.data.totalCount);
            console.log(logPrefix, 'Finished Get Notification');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed Get Notification error: ' + e);
            if (e.response && e.response.status === 500) {
                this.initNoticeList();
            }
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getNoticeContents(noticeId, locale, callback) {
        this.commonStore.setLoadingState('WAITING...');
        try {
            console.log(logPrefix, 'Start get Notice Contents.');
            const url = `detail?id=${noticeId}`
            const response = yield this.notificationRepository.getNotificationInfo(url);
            this.setType(response.data.notificationType);
            this.setSelectOption(response.data.notificationType, () => this.setContents(response.data, locale));
            this.setLocaleCode(response.data.localeCode);
            this.setBackground(response.data.backgroundColor);
            this.setDetailImages(response.data.detailImages);
            this.setId(response.data.id);
            this.setNotificationImage(response.data.notificationImage);
            this.setLocaleGroupId(response.data.localeGroupId);
            if (response.data.notificationType !== "All") {
                this.setSelectLocale(response.data.localeCode);
                if (response.data.notificationType === "Locale") {
                    this.setSelectGroupId("All");
                } else {
                    this.setSelectGroupId(response.data.localeGroupId);
                }
            }
            console.log(logPrefix, 'Finished get Notice Contents.');
            response.data.localeCode && callback && callback(response.data.localeCode);
        } catch (e) {
            console.log(logPrefix, 'Failed get Notice Contents.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    setContents = (data, locale) => {
        if (data.notificationType === "All") {
            this.setNoticeBanners(data.banners, locale);
            this.setNoticeContents(data.details, locale);
        } else {
            this.setNoticeBanners(data.banners, languageLocaleMap[data.localeCode]);
            this.setNoticeContents(data.details, languageLocaleMap[data.localeCode]);
        }
    }

    * updateNotificationEnable(enable, id, callback) {
        this.commonStore.setLoadingState('WAITING...');
        try {
            this.setEnableCheck(true);
            console.log(logPrefix, 'Start update notice Enable.');
            const url = `enable?isEnable=${!enable}&notificationId=${id}`;
            yield this.notificationRepository.updateNotificationEnable(url);
            console.log(logPrefix, 'Finished update notice Enable.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed update notice Enable.');
            this.setEnableCheck(false);
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * createAllNotice(callback) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start create notice.');
            const data = {
                backgroundColor: this.background,
                banners: this.noticeBanners,
                detailImages: this.detailImages.map(detailImage => {
                    return {
                        image: detailImage.image.split(',')[1],
                        originalFileName: detailImage.originalFileName,
                        originalFileExtension: detailImage.originalFileExtension
                    }
                }),
                details: this.noticeContents,
                id: this.id,
                ...(this.selectLocale !== "select" && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== "All" && {localeGroupId: this.selectGroupId}),
                image: this.notificationImage.image,
                notificationType: this.selectOption,
            }
            data.banners.forEach((banner, index) => {
                if (banner.languageCode === this.localeStore.locale.toUpperCase()) {
                    banner.title = this.title;
                    banner.subTitle = this.subtitle;
                }
            });
            data.details.forEach((detail, index) => {
                if (detail.languageCode === this.localeStore.locale.toUpperCase()) {
                    detail.content = this.content;
                }
            })
            yield this.notificationRepository.postNotice(data);
            console.log(logPrefix, 'Finished create notice.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed create notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * createLocaleNotice(callback) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start create notice.');
            const data = {
                backgroundColor: this.background,
                banners: [{
                    title: this.title,
                    subTitle: this.subtitle,
                    languageCode: languageLocaleMap[this.selectLocale],
                    isEnable: true,
                }],
                detailImages: this.detailImages.map(detailImage => {
                    return {
                        image: detailImage.image.split(',')[1],
                        originalFileName: detailImage.originalFileName,
                        originalFileExtension: detailImage.originalFileExtension
                    }
                }),
                details: [{
                    content: this.content,
                    languageCode: languageLocaleMap[this.selectLocale],
                }],
                id: this.id,
                ...(this.selectGroupId !== "select" && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== "All" && {localeGroupId: this.selectGroupId}),
                image: this.notificationImage.image,
                notificationType: this.selectOption,
            }
            yield this.notificationRepository.postNotice(data);
            console.log(logPrefix, 'Finished create notice.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed create notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * updateAllNotice(callback) {
        this.commonStore.setLoadingState('Updating...');
        try {
            console.log(logPrefix, 'Start update notice.');
            const data = {
                backgroundColor: this.background,
                banners: this.noticeBanners,
                detailImages: this.detailImages.map(detailImage => {
                    return {
                        image: detailImage.image.split(',')[1],
                        originalFileName: detailImage.originalFileName,
                        originalFileExtension: detailImage.originalFileExtension
                    }
                }),
                details: this.noticeContents,
                id: this.id,
                ...(this.selectLocale !== "select" && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== "All" && {localeGroupId: this.selectGroupId}),
                image: this.notificationImage.image,
                isImageChange: this.isImageChange,
                notificationType: this.selectOption,
            }
            data.banners.forEach((banner, index) => {
                if (banner.languageCode === this.localeStore.locale.toUpperCase()) {
                    banner.title = this.title;
                    banner.subTitle = this.subtitle;
                }
            });
            data.details.forEach((detail, index) => {
                if (detail.languageCode === this.localeStore.locale.toUpperCase()) {
                    detail.content = this.content;
                }
            })
            yield this.notificationRepository.putNotice(data);
            console.log(logPrefix, 'Finished update notice.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed update notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * updateLocaleNotice(callback) {
        this.commonStore.setLoadingState('Registering...');
        try {
            console.log(logPrefix, 'Start update notice.');
            const data = {
                backgroundColor: this.background,
                banners: [{
                    title: this.title,
                    subTitle: this.subtitle,
                    languageCode: languageLocaleMap[this.selectLocale],
                    isEnable: true,
                }],
                detailImages: this.detailImages.map(detailImage => {
                    return {
                        image: detailImage.image.split(',')[1],
                        originalFileName: detailImage.originalFileName,
                        originalFileExtension: detailImage.originalFileExtension
                    }
                }),
                details: [{
                    content: this.content,
                    languageCode: languageLocaleMap[this.selectLocale],
                }],
                id: this.id,
                ...(this.selectLocale !== "select" && {localeCode: this.selectLocale}),
                ...(this.selectGroupId !== "All" && {localeGroupId: this.selectGroupId}),
                image: this.notificationImage.image,
                isImageChange: this.isImageChange,
                notificationType: this.selectOption,
            }
            yield this.notificationRepository.putNotice(data);
            console.log(logPrefix, 'Finished update notice.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed update notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * deleteNotice(id, callback) {
        try {
            console.log(logPrefix, 'Start delete notice.');
            yield this.notificationRepository.deleteNotice(id);
            console.log(logPrefix, 'Finished delete notice');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed delete notice.');
        } finally {
            this.commonStore.initLoadingState();
        }
    }

}